/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedTaxSpecialRequestDto } from '../../models/backend-patched-tax-special-request-dto';
import { BackendTaxSpecialDto } from '../../models/backend-tax-special-dto';

export interface ProjectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendPatchedTaxSpecialRequestDto;
}

export function projectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxSpecialDto>;
    }),
  );
}

projectTaxesTaxSpecialPartialUpdate$XWwwFormUrlencoded.PATH = '/api/project_taxes/tax_special/{id}/';
